export default __webpack_public_path__ + "static/media/google-drive-icon.5afbd7c9.svg";